import Fetcher from '../../../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../../../constants'
import { EditFeesRequestData } from './types'

const fetcher = new Fetcher({})

export const saveSplitFees = async (data: EditFeesRequestData[]) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.COMMUNITY}`,
    method: HTTP_METHODS.PUT,
    data
  })
